export default __webpack_public_path__ + "static/media/rapidLabsLogo.80095ed8.svg";